import HttpService from '../../../services/http/httpService';
import config from '../../../config';

// silent: true en todo el servicio: la vista pinta los errores inline (listado)
// o en el modal (403/404/409 al guardar) en vez del toast global.
// verifyHeadquarter del backend solo lee `headquarter` de la query, por eso
// el PUT lo manda en la query ademas de en el body.
class PreciosService extends HttpService {
  // GET /precios/centros -> { centros: [{ id, nombre }] }
  async listarCentros({ headquarter }) {
    return this.get('precios/centros', { params: { headquarter }, silent: true });
  }

  // GET /precios -> { precios: [{ idcentro, centro, codigocurso, curso, tipo, importes... }] }
  async listarPrecios({ headquarter, idcentro, tipo, search }) {
    const params = { headquarter };
    if (idcentro !== undefined && idcentro !== null && idcentro !== '') params.idcentro = idcentro;
    if (tipo) params.tipo = tipo;
    const termino = typeof search === 'string' ? search.trim() : '';
    if (termino) params.search = termino;
    return this.get('precios', { params, silent: true });
  }

  // PUT /precios -> { precio }. `cambios` solo lleva los importes modificados.
  async actualizarPrecio({ headquarter, idcentro, codigocurso, cambios }) {
    return this.put(
      'precios',
      { headquarter, idcentro, codigocurso, ...cambios },
      { params: { headquarter }, silent: true },
    );
  }
}

const preciosService = new PreciosService(config.REACT_APP_NODE_API);
export default preciosService;
